/* eslint-disable */

import React, { useEffect, useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Card,
  CardContent,
  Button,
  Alert,
  InputAdornment,
  Grid,
  Divider,
} from '@mui/material';
import { AttachMoney, Settings } from '@mui/icons-material';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';

import api from '../../utils/functions/api';
import { getStorage } from '../../utils/functions/localstorage';
import { get } from 'lodash';

export default function Config() {
  const [keyMinAmount, setKeyMinAmount] = useState('');
  const [keyMaxAmount, setKeyMaxAmount] = useState('');
  const [minAmount, setMinAmount] = useState('');
  const [maxAmount, setMaxAmount] = useState('');
  const [errors, setErrors] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const validateAmounts = () => {
    const newErrors = {};
    const min = parseFloat(minAmount);
    const max = parseFloat(maxAmount);

    // Check if values are valid numbers
    if (!minAmount || isNaN(min) || min < 0) {
      newErrors.min = 'Please enter a valid minimum amount (≥ 0)';
    }

    if (!maxAmount || isNaN(max) || max < 0) {
      newErrors.max = 'Please enter a valid maximum amount (≥ 0)';
    }

    // Check if min is less than max
    if (!newErrors.min && !newErrors.max && min >= max) {
      newErrors.range = 'Minimum amount must be less than maximum amount';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    setShowSuccess(false);
    setShowError(false);

    if (!validateAmounts()) return;

    console.log('Saving amounts:', { min: minAmount, max: maxAmount });

    try {
      const token = getStorage('token');
      const headers = { Authorization: token };
      console.log('keyMinAmount', keyMinAmount);
      console.log('keyMaxAmount', keyMaxAmount);
      const [resMin, resMax] = await Promise.all([
        api.put(
          `${process.env.REACT_APP_APIHOST}/eentry/configs/${keyMinAmount}`,
          {
            value: parseFloat(minAmount),
          },
          { headers },
          console.log('1', 1),
        ),
        api.put(
          `${process.env.REACT_APP_APIHOST}/eentry/configs/${keyMaxAmount}`,
          {
            value: parseFloat(maxAmount),
          },
          { headers },
          console.log('2', 2),
        ),
      ]);

      if (
        resMin.data.status === 'success' &&
        resMax.data.status === 'success'
      ) {
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
      } else {
        const errMsg =
          get(resMin, 'data.message', '') ||
          get(resMax, 'data.message', '') ||
          'Failed to save config';
        setErrors({ api: errMsg });
        setShowError(true);
        console.error('Failed to save config:', errMsg);
      }
    } catch (error) {
      const errMsg = get(error, 'response.data.message', error.message);
      setErrors({ api: errMsg });
      setShowError(true);
      console.error('Error saving config:', errMsg);
    }
  };

  const handleReset = () => {
    setMinAmount('');
    setMaxAmount('');
    setErrors({});
    setShowSuccess(false);
    getData();
  };

  const handleMinChange = (event) => {
    setMinAmount(event.target.value);
    if (errors.min || errors.range) {
      const newErrors = { ...errors };
      delete newErrors.min;
      delete newErrors.range;
      setErrors(newErrors);
    }
  };

  const handleMaxChange = (event) => {
    setMaxAmount(event.target.value);
    if (errors.max || errors.range) {
      const newErrors = { ...errors };
      delete newErrors.max;
      delete newErrors.range;
      setErrors(newErrors);
    }
  };

  const getData = async () => {
    const token = getStorage('token');
    try {
      const res = await api.get(
        `${process.env.REACT_APP_APIHOST}/eentry/configs`,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      console.log('res', res);

      if (res.data.status === 'success' && Array.isArray(res.data.data)) {
        const configs = res.data.data;

        const minConfig = configs.find((c) => c.key === 'MIN_AMOUNT');
        const maxConfig = configs.find((c) => c.key === 'MAX_AMOUNT');

        if (minConfig) setMinAmount(parseFloat(minConfig.value));
        if (maxConfig) setMaxAmount(parseFloat(maxConfig.value));
        if (minConfig) setKeyMinAmount(minConfig.key);
        console.log('minConfig', minConfig);
        console.log('keyMinAmount', keyMinAmount);
        if (maxConfig) setKeyMaxAmount(maxConfig.key);
      } else {
        console.error('Failed to fetch config:', res.data.message);
      }
    } catch (error) {
      console.error('Error fetching config:', error);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <Box sx={{ maxWidth: 600, margin: '0 auto', padding: 3 }}>
      <Card elevation={3}>
        <CardContent sx={{ padding: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 3 }}>
            <Settings sx={{ marginRight: 1, color: 'primary.main' }} />
            <Typography variant="h5" component="h1" fontWeight="bold">
              จำนวนเงินขั้นต่ำ/สูงสุด
            </Typography>
          </Box>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ marginBottom: 3 }}
          >
            กำหนดจำนวนเงินขั้นต่ำและสูงสุดสำหรับการสร้างรายการ E-Entry
          </Typography>

          <Divider sx={{ marginBottom: 3 }} />

          {showSuccess && (
            <Alert severity="success" sx={{ marginBottom: 3 }}>
              การกำหนดจำนวนเงินบันทึกเรียบร้อยแล้ว!
            </Alert>
          )}
          {showError && (
            <Alert severity="error" sx={{ marginBottom: 3 }}>
              การกำหนดจำนวนเงินบันทึกไม่สำเร็จ!
            </Alert>
          )}

          {errors.range && (
            <Alert severity="error" sx={{ marginBottom: 3 }}>
              {errors.range}
            </Alert>
          )}

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Minimum Amount"
                value={minAmount}
                onChange={(e) => {
                  const val = e.target.value;
                  const regex = /^\d*\.?\d{0,2}$/; // ตัวเลข + ทศนิยมไม่เกิน 2 หลัก

                  if (val === '') {
                    // ให้ลบได้ แต่ไม่ให้เป็นค่าน้อยกว่า 1
                    handleMinChange(e);
                    return;
                  }

                  if (regex.test(val)) {
                    const num = parseFloat(val);

                    // ต้อง >= 1
                    if (!isNaN(num) && num >= 1) {
                      handleMinChange(e);
                    }
                  }
                }}
                fullWidth
                type="text" // ใช้ text เพื่อควบคุม regex เอง
                variant="outlined"
                error={!!errors.min}
                helperText={errors.min}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CurrencyBitcoinIcon />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  inputMode: 'decimal', // มือถือจะแสดง numpad
                }}
                sx={{ marginBottom: 2 }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Maximum Amount"
                value={maxAmount}
                onChange={(e) => {
                  const val = e.target.value;
                  const regex = /^\d*\.?\d{0,2}$/;
                  if (val === '' || regex.test(val)) {
                    handleMaxChange(e);
                  }
                }}
                fullWidth
                type="text"
                variant="outlined"
                error={!!errors.max}
                helperText={errors.max}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CurrencyBitcoinIcon />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  inputMode: 'decimal',
                }}
                sx={{ marginBottom: 2 }}
              />
            </Grid>
          </Grid>

          {minAmount &&
            maxAmount &&
            !errors.min &&
            !errors.max &&
            !errors.range && (
              <Box
                sx={{
                  backgroundColor: 'grey.50',
                  padding: 2,
                  borderRadius: 1,
                  marginY: 3,
                }}
              >
                <Typography variant="body2" color="text.secondary">
                  <strong>Range Preview:</strong>
                  {parseFloat(minAmount).toFixed(2)} ฿ -
                  {parseFloat(maxAmount).toFixed(2)} ฿
                </Typography>
                {/* <Typography variant="caption" color="text.secondary">
                  Difference:
                  {(parseFloat(maxAmount) - parseFloat(minAmount)).toFixed(2)} ฿
                </Typography> */}
              </Box>
            )}

          <Box
            sx={{
              display: 'flex',
              gap: 2,
              justifyContent: 'flex-end',
              marginTop: 4,
            }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={handleReset}
              disabled={!minAmount && !maxAmount}
            >
              รีเซ็ต
            </Button>
            <Button
              variant="outlined"
              color="success"
              onClick={handleSave}
              disabled={!minAmount || !maxAmount}
            >
              บันทึก
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
